import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, first } from 'rxjs';
import { ApiState } from 'src/app/model/api-state.model';
import { ModalService } from 'src/app/services/modal.service';
import * as fromConfig from '../../../store/config/config.reducer';
import * as fromProcess from '../../../store/process/process.reducer';
import { AppState } from 'src/app/store';
import { Store } from '@ngrx/store';

const PREMIUM_INCREASE_RESET_VALUE = 0;

@Component({
  selector: 'app-change-premium',
  templateUrl: './change-premium.component.html',
  styleUrls: ['./change-premium.component.scss'],
})
export class ChangePremiumComponent implements OnInit {
  form = new FormGroup({
    percentIncrease: new FormControl<number | null>(null, [Validators.required]),
  });
  premiumStatus$ = new BehaviorSubject<ApiState>(ApiState.idle);
  apiState = ApiState;
  $validationParams = this.store.select(fromConfig.selectConfigAgentValidation);
  $premiumPercentIncrease = this.store.select(fromProcess.selectPremiumPercentIncrease);

  constructor(private modalService: ModalService, private store: Store<AppState>) {}

  ngOnInit(): void {
    this.$validationParams.subscribe((params) => {
      if (params.agentMinPriceIncreasePercent !== undefined && params.agentMaxPriceIncreasePercent !== undefined) {
        this.form.controls.percentIncrease.setValidators([
          Validators.required,
          Validators.min(params.agentMinPriceIncreasePercent),
          Validators.max(params.agentMaxPriceIncreasePercent),
        ]);
      }
    });

    this.$premiumPercentIncrease.pipe(first()).subscribe((value) => {
      this.form.controls.percentIncrease.setValue(value);
    });
  }

  handleSubmit() {
    const premiumPercentIncrease = this.form.value.percentIncrease;
    if (premiumPercentIncrease || premiumPercentIncrease === PREMIUM_INCREASE_RESET_VALUE) {
      this.store.dispatch(fromProcess.actions.setAgentSectionPremiumPercentIncrease({ premiumPercentIncrease }));
    }
    this.modalService.closeModalAll();
  }
}
